import {
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const IncomeTaxMycasInfo = (props) => {
  const { open, setOpen } = props;

  const tableData = [
    {
      sNo: 1,
      category: "",
      form: "Form 5BA",
      description: "Preliminary: Certificate of an Accountant under rule 8B",
    },
    {
      sNo: 2,
      category: "",
      form: "Form 10CCB",
      description:
        "Tax Exemptions and Reliefs: Audit Report u/s 80-I(7) / 80-IA(7) / 80-IB / 80-IC / 80-IAC / 80-IE",
    },
    {
      sNo: 3,
      category: "",
      form: "Form 10BBC",
      description:
        "Tax Exemptions and Reliefs: Certificate of Accountant in respect of compliance to the provisions of clause (23FE) of Section 10 of the Income Tax Act 1961 by the Notified Pension Fund",
    },
    {
      sNo: 4,
      category: "",
      form: "Form 10BC",
      description:
        "Tax Exemptions and Reliefs: Audit Report under sub-rule (12) of Rule 17CA of the Income Tax Rules 1962 in the case of an Electoral Trust",
    },
    {
      sNo: 5,
      category: "",
      form: "Form 10-IJ",
      description:
        "Tax Exemptions & Reliefs: Certificate to be issued by an Accountant under clause (23FF) of Section 10 of the Income Tax Act 1961",
    },
    {
      sNo: 6,
      category: "",
      form: "Form 10-IL",
      description:
        "Tax Exemptions and Reliefs: Verification by an Accountant under sub-rule (3) of Rule 21AJA of the Income Tax Rules 1962",
    },
    {
      sNo: 7,
      category: "",
      form: "Form 15CB",
      description: "Deduction of Tax at Source: Certificate of an Accountant",
    },
  ];

  return (
    <DialogWrapper
      title="Important Information on Income Tax TAN My Chartered Accountant(s)"
      open={open}
      setOpen={setOpen}
      width="lg"
    >
      <Box sx={{ padding: 2, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
        <Typography variant="body1" gutterBottom mb={2}>
          <span style={{ fontWeight: "bold" }}>
            Integration of UDIN for Forms filed by a Chartered Accountant through ARCA Login:
          </span>{" "}
          While the requirement for UDIN was established in 2019, the Income Tax e-filing portal
          started integrating UDIN verification with its system from Assessment Year 2021-22. Prior
          to that, Chartered Accountants were required to generate and retain the UDIN through
          ICAI's UDIN portal independently, but there was no mandatory online linkage between the
          Income Tax e-filing portal and UDIN.
        </Typography>
        <Typography variant="body1" gutterBottom>
          The UDIN Pending list / Form where UDIN is not updated on Income Tax Portal is based on
          our best estimates and calculations. While we strive for accuracy, there may be slight
          variations due to unforeseen factors or changes in circumstances. Currently UDIN is only
          checked for below Forms from AY 2021-22;
        </Typography>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 650, borderCollapse: "collapse" }}
            aria-label="Income Tax My Chartered Accountant(s)"
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    p: 1,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="bold">S.No</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    p: 1,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="bold">Category</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    p: 1,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="bold">Form</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    p: 1,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="bold">Description</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{ border: "1px solid rgba(0,0,0,0.5)", p: 1, textAlign: "center" }}
                  >
                    <Typography variant="body2">{row.sNo}.</Typography>
                  </TableCell>

                  {index === 0 && (
                    <TableCell sx={{ border: "1px solid rgba(0,0,0,0.5)", p: 1 }} rowSpan={3}>
                      <Typography variant="body2">
                        Persons with Business / Professional Income
                      </Typography>
                    </TableCell>
                  )}
                  {index === 3 && (
                    <TableCell sx={{ border: "1px solid rgba(28, 22, 22, 0.5)", p: 1 }} rowSpan={4}>
                      <Typography variant="body2">
                        Persons not dependent on any source of Income (Source of Income not
                        relevant)
                      </Typography>
                    </TableCell>
                  )}

                  <TableCell sx={{ border: "1px solid rgba(0,0,0,0.5)", p: 1 }}>
                    <Typography variant="body2">{row.form}</Typography>
                  </TableCell>
                  <TableCell sx={{ border: "1px solid rgba(0,0,0,0.5)", p: 1 }}>
                    <Typography variant="body2">{row.description}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </DialogWrapper>
  );
};

export default IncomeTaxMycasInfo;
